var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"convey-home-page d-flex align-items-center justify-content-center px-2 py-2 px-md-4 py-md-4"},[_c('Hero')],1)}
var staticRenderFns = []

export { render, staticRenderFns }